import * as React from 'react';
import { cx } from './styles';

export const CareerBlog: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [expanded, setExpanded] = React.useState(false);

  return (
    <>
      <div id="career-blog-posts" className={cx('main_blog_layout-grid blog-grid')} data-expanded={expanded}>
        {children}
      </div>
      <div className={cx('spacer-xlarge')} />
      <button
        type="button"
        className={cx('button is-medium is-text-large is-black-on-green max-width-full')}
        aria-expanded={expanded}
        aria-controls="career-blog-posts"
        onClick={() => setExpanded(value => !value)}
      >
        {expanded ? 'Свернуть' : 'Смотреть все'}
      </button>
    </>
  );
};
